import { TranslateFn } from '../../../../hooks/context/useTranslate';
import { FilterError, MatchMode } from '../../../../types/types';
import { isEmptyValue } from '../../../../utils/managerUtils';
import { isValuelessMatchMode } from '../../../../utils/filters/isValuelessMatchMode';

export const checkFilterOnSubmit = (
  value,
  matchMode: MatchMode,
  filterError: FilterError,
  t: TranslateFn
) => {
  if (filterError) return filterError;

  const valueIsEmpty = isEmptyValue(value);
  const isBetweenMode = matchMode === 'between';

  if (valueIsEmpty && !isValuelessMatchMode(matchMode)) {
    return [t('errors.emptyFilterError')];
  }

  if (isBetweenMode && value === ',') {
    return [t('errors.emptyFilterError')];
  }

  if (
    isBetweenMode &&
    typeof value === 'string' &&
    (value.startsWith(',') || value.endsWith(','))
  ) {
    return [t('errors.invalidBetweenError')];
  }

  return filterError;
};
